import React, { useEffect, useState } from 'react';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import DiaryList from '../../components/diary-list/diary-list';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import Loading from '../../components/loading/loading';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Services
import DiaryService from '../../services/diary-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

const DiaryListContainer = () => {
  const [error, setError] = useState(false);
  const [diaries, setDiaries] = useState<ClassroomDiaryCount[]>(null);
  useEffect(() => {
    new SchoolService()
      .getSchoolById(new StorageService().getEmployee().schoolId)
      .then((school) => new DiaryService(school.uuid).listDiaryCounts())
      .then((data) => setDiaries(data))
      .catch(() => setError(true));
  }, []);

  if (error) return <ErrorComponent type='contentFull' />;

  if (!diaries) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <FeatureTitle title='diários' />
      {diaries.length > 0 ? <DiaryList diaries={diaries} /> : <Empty />}
    </BaseContentContainer>
  );
};

export default DiaryListContainer;
